let cachedId = '';

export default function getAmplitudeDeviceId(): string {
  try {
    if (typeof window === 'undefined') return '';

    const amp = (window as any).amplitude;
    if (!amp || typeof amp.getDeviceId !== 'function') {
      return cachedId || '';
    }

    const id = amp.getDeviceId();

    if (typeof id === 'string' && id) {
      cachedId = id;
      return id;
    }

    return cachedId || '';
  } catch {
    return '';
  }
}
